import { render, staticRenderFns } from "./DisplayFlexSegmentDeliveryModal.vue?vue&type=template&id=66b27308&"
import script from "./DisplayFlexSegmentDeliveryModal.vue?vue&type=script&lang=ts&"
export * from "./DisplayFlexSegmentDeliveryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports